import React, {useState} from 'react';
import {Button, Modal} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import UnlinkEmployeeModal from "./UnlinkEmployeeModal";
import UnlinkUserModal from "./UnlinkUserModal";

import styles from './UnlinkWorkspaceModal.module.scss';
import {ProjectAccents} from "../../General/config/projectAccents";

function UnlinkWorkspaceModal(props: Readonly<{
    visible: boolean,
    selectedCustomer: CustomerDTO,
    handleClose: Function,
    handleCustomerMenuModalClose: Function,
    setAlert: Function
}>) {

    const [unlinkEmployeeVisible, setUnlinkEmployeeVisible] = useState(false);
    const [unlinkUserVisible, setUnlinkUserVisible] = useState(false);

    return (
        <>
            <Modal
                visible={props.visible && !unlinkEmployeeVisible && !unlinkUserVisible}
                accent={ProjectAccents.PeoplePlanner}
                heading={'Unlink Workspace'}
                onCancelButtonClick={() => props.handleClose()}
                onClose={() => props.handleClose()}
                primaryButtonProps={{buttonStyle: {'display': 'none'}}}
            >
                <div className={styles.UnlinkWorkspaceModalButtonContainer}>
                    <div className={styles.UnlinkWorkspaceModalButtonElement}>
                        <Button
                            text={'Unlink Employee'}
                            onClick={() => setUnlinkEmployeeVisible(true)}
                        />
                    </div>
                    <div className={styles.UnlinkWorkspaceModalButtonElement}>
                        <Button
                            text={'Unlink User'}
                            onClick={() => setUnlinkUserVisible(true)}
                        />
                    </div>
                </div>
            </Modal>
            {unlinkEmployeeVisible ?
                <UnlinkEmployeeModal
                    visible={unlinkEmployeeVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setUnlinkEmployeeVisible(false)}
                    handleUnlinkWorkspaceModalClose={props.handleClose}
                    handleCustomerMenuModalClose={props.handleCustomerMenuModalClose}
                    setAlert={props.setAlert}
                /> : undefined
            }
            {unlinkUserVisible ?
                <UnlinkUserModal
                    visible={unlinkUserVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setUnlinkUserVisible(false)}
                    handleUnlinkWorkspaceModalClose={props.handleClose}
                    handleCustomerMenuModalClose={props.handleCustomerMenuModalClose}
                    setAlert={props.setAlert}
                /> : undefined
            }
        </>
    );
}

export default UnlinkWorkspaceModal;
